// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apply-overlay {

    position: fixed;
    inset: 0;

    background:
        rgba(0, 0, 0, .4);

    backdrop-filter:
        blur(10px);

    display: flex;

    justify-content: center;
    align-items: center;

    z-index: 9999;

}


.apply-modal {

    width: 650px;
    max-width: 95%;

    background: white;

    border-radius: 30px;

    padding: 35px;

    box-shadow:

        0 20px 50px rgba(0, 0, 0, .08);

    animation:
        modalShow .4s;

}


@keyframes modalShow {

    from {

        opacity: 0;
        transform:
            translateY(20px);

    }

    to {

        opacity: 1;
        transform:
            translateY(0);

    }

}


.apply-modal h2 {

    margin-bottom: 8px;

    color: #111827;

}


.apply-modal p {

    color: #64748b;

    margin-bottom: 25px;

}


.apply-modal textarea {

    width: 100%;

    height: 120px;

    padding: 18px;

    border: none;

    outline: none;

    resize: none;

    border-radius: 18px;

    background: #f8fafc;

    font-size: 15px;

    margin-bottom: 25px;

}


.upload-grid {

    display: grid;

    grid-template-columns:
        repeat(3,
            1fr);

    gap: 20px;

    margin-bottom: 30px;

}


.upload-grid label {

    height: 130px;

    border-radius: 20px;

    cursor: pointer;

    display: flex;

    flex-direction: column;

    justify-content: center;
    align-items: center;

    gap: 15px;

    background: #f8fafc;

    border: 1px solid rgba(0, 0, 0, .05);

    transition: .3s;

    padding: 10px;

    text-align: center;

    overflow: hidden;

}


.upload-grid label svg {

    font-size: 28px;

    color:
        var(--primary-100);

}


.upload-grid label:hover {

    transform:
        translateY(-3px);

    border-color:
        var(--primary-100);

}


.active-upload {

    background:

        rgba(var(--primary-100-rgb),
            .08);

    border-color:
        var(--primary-100) !important;

}


.upload-grid span {

    font-size: 13px;

    word-break: break-word;

}


.apply-buttons {

    display: flex;

    gap: 15px;

}


.apply-buttons button {

    flex: 1 1;

    height: 55px;

    border: none;

    border-radius: 18px;

    font-weight: 700;

    cursor: pointer;

    transition: .3s;

}


.apply-buttons button:first-child {

    background: #f1f5f9;

}


.send-btn {

    background:
        var(--primary-100);

    color: white;

}


.send-btn:hover {

    background:
        var(--primary-200);

}


.spin {

    animation:
        spin .8s linear infinite;

    margin-right: 10px;

}


@keyframes spin {

    to {

        transform:
            rotate(360deg);

    }

}


@media(max-width:700px) {

    .upload-grid {

        grid-template-columns:
            1fr;

    }

    .apply-buttons {

        flex-direction: column;

    }

}


.offer-field-error {
    margin-top: 10px;
    font-size: 13px;
    color: #ef4444;
    font-weight: 600;
}

.feedback {

    padding: 15px;

    border-radius: 15px;

    margin-bottom: 20px;

    font-weight: 600;

    animation:
        fadeUp .4s;

}


.feedback.success {

    background:
        rgba(34,
            197,
            94,
            0.1);

    color:
        #16a34a;

    border:
        1px solid rgba(34,
            197,
            94,
            0.2);

}


.feedback.error {

    background:
        rgba(239,
            68,
            68,
            0.08);

    color:
        #dc2626;

    border:
        1px solid rgba(239,
            68,
            68,
            0.2);

}


@keyframes fadeUp {

    from {

        opacity: 0;

        transform:
            translateY(10px);

    }

    to {

        opacity: 1;

        transform:
            translateY(0);

    }

}`, "",{"version":3,"sources":["webpack://./src/componentsL/ApplyOfferModal.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,QAAQ;;IAER;yBACqB;;IAErB;kBACc;;IAEd,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,aAAa;;AAEjB;;;AAGA;;IAEI,YAAY;IACZ,cAAc;;IAEd,iBAAiB;;IAEjB,mBAAmB;;IAEnB,aAAa;;IAEb;;sCAEkC;;IAElC;qBACiB;;AAErB;;;AAGA;;IAEI;;QAEI,UAAU;QACV;4BACoB;;IAExB;;IAEA;;QAEI,UAAU;QACV;yBACiB;;IAErB;;AAEJ;;;AAGA;;IAEI,kBAAkB;;IAElB,cAAc;;AAElB;;;AAGA;;IAEI,cAAc;;IAEd,mBAAmB;;AAEvB;;;AAGA;;IAEI,WAAW;;IAEX,aAAa;;IAEb,aAAa;;IAEb,YAAY;;IAEZ,aAAa;;IAEb,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,eAAe;;IAEf,mBAAmB;;AAEvB;;;AAGA;;IAEI,aAAa;;IAEb;;gBAEY;;IAEZ,SAAS;;IAET,mBAAmB;;AAEvB;;;AAGA;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,eAAe;;IAEf,aAAa;;IAEb,sBAAsB;;IAEtB,uBAAuB;IACvB,mBAAmB;;IAEnB,SAAS;;IAET,mBAAmB;;IAEnB,oCAAoC;;IAEpC,eAAe;;IAEf,aAAa;;IAEb,kBAAkB;;IAElB,gBAAgB;;AAEpB;;;AAGA;;IAEI,eAAe;;IAEf;0BACsB;;AAE1B;;;AAGA;;IAEI;wBACoB;;IAEpB;0BACsB;;AAE1B;;;AAGA;;IAEI;;;gBAGY;;IAEZ;qCACiC;;AAErC;;;AAGA;;IAEI,eAAe;;IAEf,sBAAsB;;AAE1B;;;AAGA;;IAEI,aAAa;;IAEb,SAAS;;AAEb;;;AAGA;;IAEI,SAAO;;IAEP,YAAY;;IAEZ,YAAY;;IAEZ,mBAAmB;;IAEnB,gBAAgB;;IAEhB,eAAe;;IAEf,eAAe;;AAEnB;;;AAGA;;IAEI,mBAAmB;;AAEvB;;;AAGA;;IAEI;0BACsB;;IAEtB,YAAY;;AAEhB;;;AAGA;;IAEI;0BACsB;;AAE1B;;;AAGA;;IAEI;gCAC4B;;IAE5B,kBAAkB;;AAEtB;;;AAGA;;IAEI;;QAEI;0BACkB;;IAEtB;;AAEJ;;;AAGA;;IAEI;;QAEI;eACO;;IAEX;;IAEA;;QAEI,sBAAsB;;IAE1B;;AAEJ;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,gBAAgB;;IAEhB;kBACc;;AAElB;;;AAGA;;IAEI;;;;gBAIY;;IAEZ;eACW;;IAEX;;;;gBAIY;;AAEhB;;;AAGA;;IAEI;;;;iBAIa;;IAEb;eACW;;IAEX;;;;gBAIY;;AAEhB;;;AAGA;;IAEI;;QAEI,UAAU;;QAEV;4BACoB;;IAExB;;IAEA;;QAEI,UAAU;;QAEV;yBACiB;;IAErB;;AAEJ","sourcesContent":[".apply-overlay {\n\n    position: fixed;\n    inset: 0;\n\n    background:\n        rgba(0, 0, 0, .4);\n\n    backdrop-filter:\n        blur(10px);\n\n    display: flex;\n\n    justify-content: center;\n    align-items: center;\n\n    z-index: 9999;\n\n}\n\n\n.apply-modal {\n\n    width: 650px;\n    max-width: 95%;\n\n    background: white;\n\n    border-radius: 30px;\n\n    padding: 35px;\n\n    box-shadow:\n\n        0 20px 50px rgba(0, 0, 0, .08);\n\n    animation:\n        modalShow .4s;\n\n}\n\n\n@keyframes modalShow {\n\n    from {\n\n        opacity: 0;\n        transform:\n            translateY(20px);\n\n    }\n\n    to {\n\n        opacity: 1;\n        transform:\n            translateY(0);\n\n    }\n\n}\n\n\n.apply-modal h2 {\n\n    margin-bottom: 8px;\n\n    color: #111827;\n\n}\n\n\n.apply-modal p {\n\n    color: #64748b;\n\n    margin-bottom: 25px;\n\n}\n\n\n.apply-modal textarea {\n\n    width: 100%;\n\n    height: 120px;\n\n    padding: 18px;\n\n    border: none;\n\n    outline: none;\n\n    resize: none;\n\n    border-radius: 18px;\n\n    background: #f8fafc;\n\n    font-size: 15px;\n\n    margin-bottom: 25px;\n\n}\n\n\n.upload-grid {\n\n    display: grid;\n\n    grid-template-columns:\n        repeat(3,\n            1fr);\n\n    gap: 20px;\n\n    margin-bottom: 30px;\n\n}\n\n\n.upload-grid label {\n\n    height: 130px;\n\n    border-radius: 20px;\n\n    cursor: pointer;\n\n    display: flex;\n\n    flex-direction: column;\n\n    justify-content: center;\n    align-items: center;\n\n    gap: 15px;\n\n    background: #f8fafc;\n\n    border: 1px solid rgba(0, 0, 0, .05);\n\n    transition: .3s;\n\n    padding: 10px;\n\n    text-align: center;\n\n    overflow: hidden;\n\n}\n\n\n.upload-grid label svg {\n\n    font-size: 28px;\n\n    color:\n        var(--primary-100);\n\n}\n\n\n.upload-grid label:hover {\n\n    transform:\n        translateY(-3px);\n\n    border-color:\n        var(--primary-100);\n\n}\n\n\n.active-upload {\n\n    background:\n\n        rgba(var(--primary-100-rgb),\n            .08);\n\n    border-color:\n        var(--primary-100) !important;\n\n}\n\n\n.upload-grid span {\n\n    font-size: 13px;\n\n    word-break: break-word;\n\n}\n\n\n.apply-buttons {\n\n    display: flex;\n\n    gap: 15px;\n\n}\n\n\n.apply-buttons button {\n\n    flex: 1;\n\n    height: 55px;\n\n    border: none;\n\n    border-radius: 18px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: .3s;\n\n}\n\n\n.apply-buttons button:first-child {\n\n    background: #f1f5f9;\n\n}\n\n\n.send-btn {\n\n    background:\n        var(--primary-100);\n\n    color: white;\n\n}\n\n\n.send-btn:hover {\n\n    background:\n        var(--primary-200);\n\n}\n\n\n.spin {\n\n    animation:\n        spin .8s linear infinite;\n\n    margin-right: 10px;\n\n}\n\n\n@keyframes spin {\n\n    to {\n\n        transform:\n            rotate(360deg);\n\n    }\n\n}\n\n\n@media(max-width:700px) {\n\n    .upload-grid {\n\n        grid-template-columns:\n            1fr;\n\n    }\n\n    .apply-buttons {\n\n        flex-direction: column;\n\n    }\n\n}\n\n\n.offer-field-error {\n    margin-top: 10px;\n    font-size: 13px;\n    color: #ef4444;\n    font-weight: 600;\n}\n\n.feedback {\n\n    padding: 15px;\n\n    border-radius: 15px;\n\n    margin-bottom: 20px;\n\n    font-weight: 600;\n\n    animation:\n        fadeUp .4s;\n\n}\n\n\n.feedback.success {\n\n    background:\n        rgba(34,\n            197,\n            94,\n            0.1);\n\n    color:\n        #16a34a;\n\n    border:\n        1px solid rgba(34,\n            197,\n            94,\n            0.2);\n\n}\n\n\n.feedback.error {\n\n    background:\n        rgba(239,\n            68,\n            68,\n            0.08);\n\n    color:\n        #dc2626;\n\n    border:\n        1px solid rgba(239,\n            68,\n            68,\n            0.2);\n\n}\n\n\n@keyframes fadeUp {\n\n    from {\n\n        opacity: 0;\n\n        transform:\n            translateY(10px);\n\n    }\n\n    to {\n\n        opacity: 1;\n\n        transform:\n            translateY(0);\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
